module.exports = "/_next/static/images/ReplayData@2x-0fccf239c16a3f4a87bd882cbfa64803.png";